<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn w-160">
      <!-- trainTypeList -->
      <el-cascader v-model="filters.trainTypeList" :options="treeCdata" :props="props" placeholder="班级类型(多选)"
        @change="trainTypeChange" collapse-tags :clearable="false" class="select_btn_style" />
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.classStatus" placeholder="班级状态">
        <el-option v-for="(item, i) in classStatusData" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-date-picker class="select_btn_style" v-model="filters.classYear" :editable="false" type="year"
        value-format="yyyy" :picker-options="pickerOptions1" placeholder="年份">
      </el-date-picker>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.delayStatus" placeholder="延期状态">
        <el-option v-for="(item, i) in delayStatusData" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn_170">
      <el-select
        class="select_btn_style"
        v-model="filters.isAllGraduation"
        placeholder="是否全部学员已结业"
      >
        <el-option
          v-for="(item, i) in publicData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input prefix-icon="el-icon-search" size="small" v-model.trim="filters.className"
        placeholder="班级名称"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { treeChildVos } from "@/api/classOffline";
import { getEnums } from '@/utils/common.js'
import butn from "@/components/button/index";
export default {
  components: { butn },
  data() {
    return {
      props: {
        //树形
        value: "key",
        label: "name",
        children: "children",
        multiple: true,
        // checkStrictly: true,
      },
      filters: {},
      trainTypeData: [],
      classStatusData: [],
      treeCdata: [],
      publicData: [],
      pickerOptions1: {
        disabledDate: (time) => {
          let minDate = new Date('2000-01-01 00:00:00');
          return time.getTime() > Date.now() || time.getTime() < minDate.getTime();
        },
      },
      delayStatusData: [],
    };
  },
  created() {
    getEnums(["CLASS_TYPE_DOWN", "CLASS_STATUS", "DELAY_STATUS", "IS_VALID"], this, ['trainTypeData', 'classStatusData', 'delayStatusData', 'publicData'], [true, true, true, true])
    treeChildVos({ type: "CLASS_TYPE_NEW" }).then((res) => {
      if (!res || res.code != 0) return;
      this.treeCdata = res.data;
    });
  },
  methods: {
    trainTypeChange(val) {
      console.log(val);
    },
    initData() {
      const baseTrainTypeList = this.filters.trainTypeList || [];
      let trainTypeList = [];
      if (baseTrainTypeList && baseTrainTypeList.length > 0) {
        baseTrainTypeList.forEach((x) => {
          if (x && x.length > 1) {
            trainTypeList.push(x[1]);
          } else {
            trainTypeList.push(x[0]);
          }
        });
      }
      let params = {
        ...this.filters,
        t: new Date().getTime(),
      };
      if (trainTypeList.length > 0) {
        params.trainTypeList = trainTypeList;
      }
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.initData();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}

.width-adapt {
  width: 135px;
}

/deep/ .el-cascader .el-input .el-input__inner {
  background: #edf2f9;
}

.w-160 {
  width: 160px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 120px;
}
</style>
